import { createFileRoute, Navigate } from '@tanstack/react-router';
import { SwitchPage } from '../components/pages/SwitchPage/SwitchPage';
import { useApiState } from '../contexts/ApiContext';

function SwitchGuard() {
  const state = useApiState();
  switch (state) {
    case 'authenticated':
      return <SwitchPage />;
    case 'unauthenticated':
      return <Navigate to="/auth" replace />;

    default:
      return null;
  }
}

export const Route = createFileRoute('/switch')({
  component: SwitchGuard,
});
